// import { Link, useNavigate } from "react-router-dom";
// import { useState, useEffect } from "react";
// import Header from "../../Common/Layout/Header";
// import jsonData from "../../VisaData/b2bvisas.json";
// import styles from "./Search.module.css";
// import config from "../../Common/Configurations/APIConfig";
// import moment from "moment";
// import VisaTabs from "../AllTabs/VisaTabs";
// import { useAuth } from "../../Common/Configurations/AuthContext";
// import apiService from "../../Common/Configurations/APIService";
// import ApplicantForm from "./ApplicantForm";
// import VisaOffers from "../Advertisements/VisaOffers";
// import VisaSidebarOffers from "../Advertisements/VisaSidebarOffers";
// import DefaultData from "../../CompanyData/DefaultData";

// // Add CSS for z-index management
// const customStyles = `
//   .search-visas-container .search-dropdown-wrapper {
//     position: relative;
//     z-index: 1050;
//   }
  
//   .search-visas-container .search-suggestions-list {
//     position: absolute;
//     top: 100%;
//     left: 0;
//     right: 0;
//     background: white;
//     border: 1px solid #dee2e6;
//     border-top: none;
//     border-radius: 0 0 0.375rem 0.375rem;
//     max-height: 300px;
//     overflow-y: auto;
//     z-index: 1060;
//     box-shadow: 0 4px 6px rgba(0,0,0,0.1);
//     margin-top: -1px;
//   }
  
//   .search-visas-container .modal-overlay {
//     z-index: 1080 !important;
//   }
  
//   .search-visas-container .sticky-header {
//     position: sticky;
//     top: 0;
//     background: white;
//     z-index: 1040;
//     box-shadow: 0 2px 4px rgba(0,0,0,0.1);
//   }
  
//   .search-visas-container .hot-deals-section {
//     position: relative;
//     z-index: 1;
//   }
  
//   .search-visas-container .sidebar-sticky {
//     position: sticky;
//     top: 100px;
//     z-index: 2;
//   }
  
//   .search-visas-container .main-content-section {
//     position: relative;
//     z-index: 1;
//   }
// `;

// export default function Visas() {
//   const { user, loading } = useAuth();
//   const navigate = useNavigate();
//   const today = new Date();
//   const futureDate = new Date(today);
//   const [inputValue, setInputValue] = useState("");
//   const [filteredSuggestions, setFilteredSuggestions] = useState([]);
//   const [isDropdownVisible, setIsDropdownVisible] = useState(false);
//   const [visas, setVisas] = useState([]);
//   const [documents, setDocuments] = useState([]);
//   const [terms, setTerms] = useState([]);
//   const [faqs, setFaqs] = useState([]);
//   const [loadingStates, setLoadingStates] = useState({});
//   const [searchLoading, setSearchLoading] = useState(false);
//   const [selectedCountry, setSelectedCountry] = useState(null);
//   const [activeTab, setActiveTab] = useState("visas");
//   const [btnLoading, setBtnLoading] = useState(false);
//   const [selectedVisa, setSelectedVisa] = useState(null);
//   const [showVisaModal, setShowVisaModal] = useState(false);
//   const [shareLoading, setShareLoading] = useState(false);
//   const [modalLoading, setModalLoading] = useState(false);

//   // ========== COMMENTED OUT BEST PRICE STATES ==========
//   // const [bestPrices, setBestPrices] = useState({});
//   // const [bestPricesLoading, setBestPricesLoading] = useState({});

//   // ========== ADDED SUPPLIER MODAL STATES ==========
//   const [suppliers, setSuppliers] = useState([]);
//   const [supplierSearch, setSupplierSearch] = useState("");
//   const [showSupplierModal, setShowSupplierModal] = useState(false);
//   const [selectedSupplier, setSelectedSupplier] = useState(null);

//   // New states for visa applicant form
//   const [showApplicantForm, setShowApplicantForm] = useState(false);
//   const [createdVisaRequest, setCreatedVisaRequest] = useState(null);
//   const [applicantsList, setApplicantsList] = useState([]);

//   // State to track if search has been performed
//   const [hasSearched, setHasSearched] = useState(false);

//   // New state for confirmation modal
//   const [showConfirmationModal, setShowConfirmationModal] = useState(false);
//   const [pendingSupplierAction, setPendingSupplierAction] = useState(null);

//   // Add custom styles to document head
//   useEffect(() => {
//     const styleElement = document.createElement("style");
//     styleElement.innerHTML = customStyles;
//     document.head.appendChild(styleElement);

//     return () => {
//       document.head.removeChild(styleElement);
//     };
//   }, []);

//   const handleReset = () => {
//     setInputValue("");
//     setFilteredSuggestions([]);
//     setIsDropdownVisible(false);
//     setSelectedCountry(null);
//     setVisas([]);
//     setDocuments([]);
//     setTerms([]);
//     setFaqs([]);
//     setLoadingStates({});
//     setSearchLoading(false);
//     setSelectedVisa(null);
//     setShowVisaModal(false);
//     setShareLoading(false);
//     setModalLoading(false);
//     setShowSupplierModal(false);
//     setSupplierSearch("");
//     setSelectedSupplier(null);
//     setShowApplicantForm(false);
//     setCreatedVisaRequest(null);
//     setApplicantsList([]);
//     setHasSearched(false);
//     setShowConfirmationModal(false);
//     setPendingSupplierAction(null);
//     // ========== COMMENTED OUT BEST PRICE RESET ==========
//     // setBestPrices({});
//     // setBestPricesLoading({});
//   };

//   const handleInputChange = (e) => {
//     const query = e.target.value;
//     setInputValue(query);

//     if (query.length > 0) {
//       setSearchLoading(true);
//       const filtered = jsonData.filter((item) =>
//         item.name.toLowerCase().includes(query.toLowerCase())
//       );
//       setTimeout(() => {
//         setFilteredSuggestions(filtered);
//         setIsDropdownVisible(true);
//         setSearchLoading(false);
//       }, 300);
//     } else {
//       setFilteredSuggestions([]);
//       setIsDropdownVisible(false);
//       setSearchLoading(false);
//     }
//   };

//   const handleSuggestionClick = async (suggestion) => {
//     setInputValue(suggestion.name);
//     setSelectedCountry(suggestion.name);
//     setIsDropdownVisible(false);
//     setSearchLoading(true);
//     setHasSearched(true);

//     setTimeout(() => {
//       console.log(suggestion);
//       if (suggestion.visas !== null) {
//         setVisas(suggestion.visas);

//         const initialLoadingStates = {};
//         // ========== COMMENTED OUT BEST PRICE LOADING STATES ==========
//         // const initialBestPricesLoading = {};
//         suggestion.visas.forEach((visa, index) => {
//           initialLoadingStates[index] = false;
//           // initialBestPricesLoading[index] = false;
//         });
//         setLoadingStates(initialLoadingStates);
//         // setBestPricesLoading(initialBestPricesLoading);

//         // ========== COMMENTED OUT BEST PRICE FETCHING ==========
//         // suggestion.visas.forEach((visa, index) => {
//         //   fetchBestPrice(visa.visaId, index);
//         // });
//       }
//       if (suggestion.visaDocuments !== null) {
//         setDocuments(suggestion.visaDocuments);
//       }
//       if (suggestion.visaTerms !== null) {
//         setTerms(suggestion.visaTerms);
//       }
//       if (suggestion.visaFAQs !== null) {
//         setFaqs(suggestion.visaFAQs);
//       }
//       setSearchLoading(false);
//     }, 500);
//   };

//   // ========== COMMENTED OUT BEST PRICE FETCHING FUNCTION ==========
//   // const fetchBestPrice = async (visaId, index) => {
//   //   if (!visaId) return;

//   //   setBestPricesLoading((prev) => ({ ...prev, [index]: true }));

//   //   try {
//   //     const url = `${config.GETBESTPRICEBYVISAID}/${visaId}`;
//   //     const response = await apiService.getAll(url);

//   //     setBestPrices((prev) => ({
//   //       ...prev,
//   //       [visaId]: response,
//   //     }));
//   //   } catch (error) {
//   //     console.error(`Error fetching best price for visa ${visaId}:`, error);
//   //     setBestPrices((prev) => ({
//   //       ...prev,
//   //       [visaId]: {
//   //         adultPrice: 0,
//   //         childPrice: 0,
//   //         supplierName: "Price not available",
//   //         supplierId: null,
//   //       },
//   //     }));
//   //   } finally {
//   //     setBestPricesLoading((prev) => ({ ...prev, [index]: false }));
//   //   }
//   // };

//   const handleViewVisa = (visa) => {
//     setSelectedVisa(visa);
//     setShowVisaModal(true);
//     setModalLoading(false);
//   };

//   // Function to fetch applicants for a visa request
//   const GetApplicants = async (visaRequestId) => {
//     try {
//       const url = `${config.GETVISAAPPLICANTSBYREQUEST}/${createdVisaRequest.visaRequestId}`;
//       console.log("Fetching applicants from:", url);
//       const res = await apiService.getAll(url);
//       setApplicantsList(res || []);
//     } catch (error) {
//       console.error("Error fetching applicants:", error);
//       setApplicantsList([]);
//     }
//   };

//   const handleSubmit = async (e, visa, index, supplierId = null) => {
//     e.preventDefault();

//     setLoadingStates((prev) => ({
//       ...prev,
//       [index]: true,
//     }));

//     const formData = {
//       visaRequestId: "00000000-0000-0000-0000-000000000000",
//       visaId: visa.visaId,
//       companyId: supplierId || "00000000-0000-0000-0000-000000000000",
//       leadSource: "B2B",
//       visaName: visa.visaName,
//       countryName: visa.visaCountryName,
//       travelDate: moment(new Date()).format("YYYY-MM-DD"),
//       expectedDate: moment(
//         futureDate.setDate(
//           today.getDate() + parseInt(visa?.processingTime + 1, 10)
//         )
//       ).format("YYYY-MM-DD"),
//       noOfApplicants: 0,
//       userId: user.id,
//       email: user.email,
//       mobile: user.phoneNumber,
//       visaRequestStatus: "PENDING",
//       paymentStatus: "PENDING",
//       serviceFee: DefaultData.SERVICEFEE,
//     };

//     try {
//       const res = await apiService.post(config.CREATEVISAREQUEST, formData);

//       if (supplierId) {
//         setCreatedVisaRequest(res);
//         setShowApplicantForm(true);
//         setTimeout(() => {
//           GetApplicants(res.visaRequestId);
//         }, 100);
//       } else {
//         navigate("/request/" + res.visaRequestId);
//       }
//     } catch (error) {
//       console.error("Error creating visa request:", error);
//       alert("Failed to create visa request. Please try again.");
//     } finally {
//       setLoadingStates((prev) => ({
//         ...prev,
//         [index]: false,
//       }));
//     }
//   };

//   // ========== COMMENTED OUT FORMAT PRICE WITH BEST PRICES ==========
//   // const formatPrice = (visa, index) => {
//   //   const bestPrice = bestPrices[visa.visaId];

//   //   if (bestPricesLoading[index]) {
//   //     return (
//   //       <div className="d-flex flex-column">
//   //         <div
//   //           className="spinner-border spinner-border-sm text-primary"
//   //           role="status"
//   //         >
//   //           <span className="visually-hidden">Loading...</span>
//   //         </div>
//   //         <small className="text-muted">Loading price...</small>
//   //       </div>
//   //     );
//   //   }

//   //   if (bestPrice && (bestPrice.adultPrice > 0 || bestPrice.childPrice > 0)) {
//   //     return (
//   //       <div className="d-flex flex-column">
//   //         {bestPrice.adultPrice > 0 && (
//   //           <span className="fw-bold text-success">
//   //             Adult: INR{bestPrice.adultPrice}
//   //           </span>
//   //         )}
//   //         {bestPrice.childPrice > 0 && (
//   //           <span className="fw-bold text-primary">
//   //             Child: INR{bestPrice.childPrice}
//   //           </span>
//   //         )}
//   //       </div>
//   //     );
//   //   } else {
//   //     return <span className="text-warning fw-bold">Contact for price</span>;
//   //   }
//   // };

//   // ========== UPDATED TO USE OLD CODE'S FORMAT PRICE FUNCTION ==========
//   const formatPrice = (visa) => {
//     if (visa.adultPrice && visa.childPrice) {
//       return (
//         <div className="d-flex flex-column">
//           <span className="fw-bold text-success">
//             Adult: INR{visa.adultPrice}
//           </span>
//           <span className="fw-bold text-primary">
//             Child: INR{visa.childPrice}
//           </span>
//         </div>
//       );
//     } else if (visa.adultPrice) {
//       return <span className="fw-bold text-success">₹{visa.adultPrice}</span>;
//     } else if (visa.childPrice) {
//       return <span className="fw-bold text-primary">₹{visa.childPrice}</span>;
//     } else {
//       return <span className="text-warning fw-bold">Contact for price</span>;
//     }
//   };

//   // ========== COMMENTED OUT DIRECT APPLY WITH BEST PRICE ==========
//   // const handleDirectApply = (visa, index) => {
//   //   const bestPrice = bestPrices[visa.visaId];

//   //   if (bestPrice && bestPrice.supplierId) {
//   //     setPendingSupplierAction({
//   //       visa,
//   //       index,
//   //       supplierId: bestPrice.supplierId,
//   //       supplierName: bestPrice.supplierName,
//   //     });
//   //     setShowConfirmationModal(true);
//   //   } else {
//   //     const syntheticEvent = { preventDefault: () => {} };
//   //     handleSubmit(syntheticEvent, visa, index);
//   //   }
//   // };

//   // ========== ADDED SUPPLIER MODAL FUNCTIONS ==========
//   const handleOpenSupplierModal = (visa) => {
//     if (visa && visa.visaId) {
//       setSelectedVisa(visa);
//       setShowSupplierModal(true);
//       setSupplierSearch("");
//     } else {
//       console.error("Invalid visa object passed to handleOpenSupplierModal");
//     }
//   };

//   const handleCloseSupplierModal = () => {
//     setShowSupplierModal(false);
//     setSupplierSearch("");
//     setSelectedSupplier(null);
//   };

//   const GetSuppliers = async (searchQuery) => {
//     if (!selectedVisa) return;

//     try {
//       let url = `${config.GETSUPPLIERVISAPRICESBYVISAID}/${selectedVisa.visaId}`;
//       if (searchQuery) {
//         url += `?search=${encodeURIComponent(searchQuery)}`;
//       }

//       const res = await apiService.getAll(url);
//       setSuppliers(res);
//     } catch (error) {
//       console.error("Error fetching supplier visa prices:", error);
//       setSuppliers([]);
//     }
//   };

//   const handleSupplierSelection = (supplier, index) => {
//     setPendingSupplierAction({ supplier, index });
//     setShowConfirmationModal(true);
//   };

//   const shareViaWhatsApp = async (visa) => {
//     setShareLoading(true);
//     await new Promise((resolve) => setTimeout(resolve, 500));

//     const websiteUrl = "https://www.visaproservices.com";
    
//     // ========== COMMENTED OUT BEST PRICE USAGE ==========
//     // const bestPrice = bestPrices[visa.visaId];
//     // const priceInfo = bestPrice
//     //   ? `• *Adult Price:* ₹${
//     //       bestPrice.adultPrice || "N/A"
//     //     }\n• *Child Price:* ₹${bestPrice.childPrice || "N/A"}`
//     //   : "• *Price:* Contact for details";
    
//     // ========== UPDATED PRICE INFO TO USE VISA'S PRICES ==========
//     const priceInfo = visa.adultPrice && visa.childPrice
//       ? `• *Adult Price:* INR${visa.adultPrice}\n• *Child Price:* INR${visa.childPrice}`
//       : visa.adultPrice
//       ? `• *Price:* INR${visa.adultPrice}`
//       : visa.childPrice
//       ? `• *Price:* INR${visa.childPrice}`
//       : "• *Price:* Contact for details";

//     const message = `🏢 *${user.brandName}*

// 🌟 *Visa Information for ${selectedCountry}* 🌟

// 📋 *Visa Details:*
// • *Visa Name:* ${visa.visaName}
// • *Type:* ${visa.visaType}
// • *Entry:* ${visa.entry}
// • *Stay Period:* ${visa.stayPeriod}
// • *Validity:* ${visa.validity}

// 💰 *Pricing (INR):*
// ${priceInfo}

// 📄 *Required Documents:*
// ${documents.map((doc, index) => `• ${doc.documentName}`).join("\n")}

// 🌐 *Apply Now:* ${websiteUrl}/apply?country=${encodeURIComponent(
//       selectedCountry
//     )}&visa=${encodeURIComponent(visa.visaName)}

// 💬 *Thank you for your interest in ${user.brandName}!*
// We're here to assist you with your visa application process. Feel free to contact us for any queries or assistance.

// 👤 *Contact Details:*
// • *Name:* ${user.name}
// • *Email:* ${user.email}
// • *Phone:* ${user.phoneNumber}

// *Note:* Terms and conditions apply.`;

//     const encodedMessage = encodeURIComponent(message);
//     const whatsappUrl = `https://web.whatsapp.com/send?text=${encodedMessage}`;
//     window.open(whatsappUrl, "_blank");
//     setShareLoading(false);
//   };

//   // ========== ADDED CONFIRMED APPLICATION HANDLER ==========
//   const handleConfirmedApplication = () => {
//     if (pendingSupplierAction) {
//       const { supplier, index } = pendingSupplierAction;
//       setSelectedSupplier(supplier);
//       const syntheticEvent = { preventDefault: () => {} };
//       handleSubmit(
//         syntheticEvent,
//         selectedVisa,
//         index,
//         supplier.supplierId
//       );
//     }
//     setShowConfirmationModal(false);
//     setPendingSupplierAction(null);
//   };

//   // ========== ADDED CANCEL APPLICATION HANDLER ==========
//   const handleCancelApplication = () => {
//     setShowConfirmationModal(false);
//     setPendingSupplierAction(null);
//   };

//   // Handle applicant form success
//   const handleApplicantFormSuccess = () => {
//     if (createdVisaRequest) {
//       GetApplicants(createdVisaRequest.visaRequestId);
//     }
//   };

//   // Handle applicant form close
//   const handleApplicantFormClose = () => {
//     setShowApplicantForm(false);
//     if (createdVisaRequest) {
//       navigate("/request/" + createdVisaRequest.visaRequestId);
//     }
//   };

//   // ========== ADDED USEFFECT FOR SUPPLIER FETCHING ==========
//   useEffect(() => {
//     if (showSupplierModal && selectedVisa) {
//       GetSuppliers("");
//     }
//   }, [showSupplierModal, selectedVisa]);

//   if (loading) return <p>Loading...</p>;
//   if (!user) {
//     navigate("/");
//   }

//   return (
//     <div id="layout-wrapper" className="search-visas-container">
//       <Header></Header>
//       <div class="vertical-overlay"></div>
//       <div className="main-content">
//         <div className="page-content">
//           <div className="container-fluid">
//             <div className="row" id="contactList">
//               <div className="col-lg-12">
//                 <div className="card">
//                   <div className="p-2">
//                     <VisaTabs pageName="VISAS" />{" "}
//                   </div>
//                   <div className="card-header d-flex align-items-center border-0">
//                     <h5 className="card-title mb-0 flex-grow-1">
//                       SEARCH & APPLY VISAS
//                     </h5>
//                   </div>
//                   <div className="card-body">
//                     <div className="row g-2 align-items-center">
//                       <div className="col-xl-4 col-md-6">
//                         <div className="search-box">
//                           <input
//                             type="text"
//                             value={inputValue}
//                             onChange={handleInputChange}
//                             placeholder="Enter country Name..."
//                             className="form-control"
//                           />
//                         </div>
//                         {isDropdownVisible && (
//                           <ul className={styles.suggestionsList}>
//                             {filteredSuggestions.map((suggestion) => (
//                               <li
//                                 key={suggestion.visaUrl}
//                                 className={`${styles.suggestionItem} list-group-item list-group-item-action`}
//                                 onClick={() =>
//                                   handleSuggestionClick(suggestion)
//                                 }
//                               >
//                                 <span className={styles.flag}>
//                                   <img
//                                     src={`https://flagcdn.com/w40/${suggestion.flagSrc.toLowerCase()}.png`}
//                                     alt={suggestion.name}
//                                     className={styles.flagImage}
//                                   />
//                                 </span>
//                                 {suggestion.name}
//                               </li>
//                             ))}
//                           </ul>
//                         )}
//                       </div>

//                       <div className="col-auto">
//                         <button
//                           className="btn btn-danger"
//                           onClick={handleReset}
//                         >
//                           <i className="ri-refresh-line align-bottom me-1"></i>{" "}
//                           Reset
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 {hasSearched && (
//                   <div className="row mt-3">
//                     <div className="col-lg-3">
//                       <div className="card">
//                         <div className="card-body">
//                           <div className="sidebar-sticky">
//                             <VisaSidebarOffers />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="col-lg-9 main-content-section">
//                       <div className="card">
//                         <div className="card-body">
//                           <div className="table-responsive table-card">
//                             <table
//                               className="table align-middle table-nowrap"
//                               id="customerTable"
//                             >
//                               <thead className="table-light text-muted">
//                                 <tr>
//                                   <th>SNo</th>
//                                   <th>Visa Details</th>
//                                   <th>Validity</th>
//                                   <th>Price (INR)</th>
//                                   <th>Action</th>
//                                 </tr>
//                               </thead>
//                               <tbody className="list form-check-all">
//                                 {searchLoading ? (
//                                   <tr>
//                                     <td
//                                       colSpan="5"
//                                       className="text-center py-3"
//                                     >
//                                       <div
//                                         className="spinner-border text-primary"
//                                         role="status"
//                                       >
//                                         <span className="visually-hidden">
//                                           Loading...
//                                         </span>
//                                       </div>
//                                     </td>
//                                   </tr>
//                                 ) : visas.length > 0 ? (
//                                   visas.map((v, index) => (
//                                     <tr key={index}>
//                                       <td className="sno">{index + 1}</td>
//                                       <td>
//                                         <div className="d-flex flex-column">
//                                           <span className="fw-semibold">
//                                             {v.visaName}
//                                           </span>
//                                           <div className="d-flex flex-wrap gap-2 mt-1">
//                                             <span className="badge bg-primary text-white">
//                                               {v.visaType}
//                                             </span>
//                                             <span className="badge bg-success text-white">
//                                               {v.entry}
//                                             </span>
//                                             <span className="badge bg-info text-white">
//                                               {v.stayPeriod}
//                                             </span>
//                                           </div>
//                                         </div>
//                                       </td>
//                                       <td className="validity">{v.validity}</td>
//                                       <td className="price">
//                                         {/* ========== UPDATED TO USE OLD CODE'S FORMAT ========== */}
//                                         {formatPrice(v)}
//                                       </td>
//                                       <td className="status">
//                                         <button
//                                           className="btn btn-sm btn-primary edit-item-btn me-2"
//                                           onClick={() => handleViewVisa(v)}
//                                           title="View Visa Details"
//                                           disabled={loadingStates[index]}
//                                         >
//                                           <i className="ri-eye-line me-1"></i>{" "}
//                                           View
//                                         </button>
//                                         {/* ========== CHANGED TO OPEN SUPPLIER MODAL ========== */}
//                                         <button
//                                           className="btn btn-sm btn-success edit-item-btn"
//                                           onClick={() =>
//                                             handleOpenSupplierModal(v)
//                                           }
//                                           disabled={loadingStates[index]}
//                                         >
//                                           SHOW PRICE
//                                         </button>
//                                       </td>
//                                     </tr>
//                                   ))
//                                 ) : (
//                                   <tr>
//                                     <td
//                                       colSpan="5"
//                                       className="text-center py-4"
//                                     >
//                                       <div className="text-muted">
//                                         <i className="ri-search-line display-4"></i>
//                                         <p className="mt-2">
//                                           No visas found for the selected
//                                           country
//                                         </p>
//                                       </div>
//                                     </td>
//                                   </tr>
//                                 )}
//                               </tbody>
//                             </table>
//                           </div>

//                           {visas.length > 0 && (
//                             <>
//                               <div className="mb-3">
//                                 <div className="list-group nested-list nested-sortable">
//                                   <div className="list-group-item nested-1">
//                                     Documents
//                                     <div className="list-group nested-list nested-sortable">
//                                       {documents.length > 0 &&
//                                         documents.map((d, index) => (
//                                           <div
//                                             key={index}
//                                             className="list-group-item nested-2"
//                                           >
//                                             {index + 1}. {d.documentName}
//                                           </div>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 </div>
//                               </div>
//                               <div className="mb-3">
//                                 <div className="list-group nested-list nested-sortable">
//                                   <div className="list-group-item nested-1">
//                                     Terms and Conditions
//                                     <div className="list-group nested-list nested-sortable">
//                                       {terms.length > 0 &&
//                                         terms.map((d, index) => (
//                                           <div
//                                             key={index}
//                                             className="list-group-item nested-2"
//                                           >
//                                             {index + 1}. {d.termsandConditions}
//                                           </div>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 </div>
//                               </div>
//                               <div className="mb-3">
//                                 <div className="list-group nested-list nested-sortable">
//                                   <div className="list-group-item nested-1">
//                                     Frequently Asked Questions
//                                     <div className="list-group nested-list nested-sortable">
//                                       {faqs.length > 0 &&
//                                         faqs.map((d, index) => (
//                                           <div
//                                             key={index}
//                                             className="list-group-item nested-2"
//                                           >
//                                             {d.question}
//                                             <div className="list-group-item nested-3">
//                                               {d.answer}
//                                             </div>
//                                           </div>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 </div>
//                               </div>
//                             </>
//                           )}
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </div>
//               {!hasSearched && (
//                 <div className="hot-deals-section mt-3">
//                   <VisaOffers />
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Visa Details Modal */}
//       {showVisaModal && selectedVisa && (
//         <div
//           className="modal fade show d-block modal-overlay"
//           style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//         >
//           <div className="modal-dialog modal-lg modal-dialog-centered">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title">
//                   Visa Details - {selectedVisa.visaName}
//                 </h5>
//               </div>
//               <div className="modal-body">
//                 <div className="row">
//                   <div className="row">
//                     <div className="row">
//                       <div className="col-md-12 mb-3">
//                         <h6>Visa Information</h6>
//                         <div className="row">
//                           <div className="col-md-4 mb-2">
//                             <div className="d-flex justify-content-between border p-2 rounded">
//                               <span className="fw-bold">Visa Type:</span>
//                               <span>{selectedVisa.visaType}</span>
//                             </div>
//                           </div>
//                           <div className="col-md-4 mb-2">
//                             <div className="d-flex justify-content-between border p-2 rounded">
//                               <span className="fw-bold">Entry Type:</span>
//                               <span>{selectedVisa.entry}</span>
//                             </div>
//                           </div>
//                           <div className="col-md-4 mb-2">
//                             <div className="d-flex justify-content-between border p-2 rounded">
//                               <span className="fw-bold">Stay Period:</span>
//                               <span>{selectedVisa.stayPeriod}</span>
//                             </div>
//                           </div>
//                           <div className="col-md-4 mb-2">
//                             <div className="d-flex justify-content-between border p-2 rounded">
//                               <span className="fw-bold">Validity:</span>
//                               <span>{selectedVisa.validity}</span>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="mt-2">
//                   <h6>Required Documents</h6>
//                   <div className="list-group">
//                     {documents.length > 0 ? (
//                       documents.map((doc, index) => (
//                         <div key={index} className="list-group-item">
//                           {index + 1}. {doc.documentName}
//                         </div>
//                       ))
//                     ) : (
//                       <div className="list-group-item text-muted">
//                         No documents required
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn btn-danger"
//                   onClick={() => setShowVisaModal(false)}
//                   disabled={shareLoading}
//                 >
//                   Close
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-primary text-white"
//                   onClick={() => shareViaWhatsApp(selectedVisa)}
//                   disabled={shareLoading}
//                 >
//                   {shareLoading ? (
//                     <>
//                       <div
//                         className="spinner-border spinner-border-sm me-1"
//                         role="status"
//                       >
//                         <span className="visually-hidden">Loading...</span>
//                       </div>
//                       SHARING...
//                     </>
//                   ) : (
//                     <>
//                       <i className="ri-whatsapp-line me-1"></i> Share
//                     </>
//                   )}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ========== ADDED SUPPLIER MODAL ========== */}
//       {showSupplierModal && (
//         <div
//           className="modal fade show d-block modal-overlay"
//           tabIndex="-1"
//           role="dialog"
//           style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//         >
//           <div className="modal-dialog modal-md" role="document">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <div>
//                   <h5 className="modal-title mb-1">
//                     Available Suppliers - {selectedCountry}
//                   </h5>
//                   {selectedVisa?.visaName && (
//                     <div className="fw-bold text-primary fs-6">
//                       {selectedVisa.visaName}
//                     </div>
//                   )}
//                 </div>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   onClick={handleCloseSupplierModal}
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 <div className="mb-3">
//                   <label className="form-label">Search Suppliers</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Type supplier name, email, or phone..."
//                     value={supplierSearch}
//                     onChange={(e) => {
//                       setSupplierSearch(e.target.value);
//                       GetSuppliers(e.target.value);
//                     }}
//                   />
//                 </div>

//                 <div
//                   className="table-responsive"
//                   style={{ maxHeight: "300px", overflowY: "auto" }}
//                 >
//                   <table className="table table-hover align-middle">
//                     <thead
//                       style={{
//                         position: "sticky",
//                         top: 0,
//                         background: "white",
//                         zIndex: 1,
//                       }}
//                     >
//                       <tr>
//                         <th>Supplier</th>
//                         <th>Contact</th>
//                         <th>Action</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {suppliers && suppliers.length > 0 ? (
//                         suppliers.map((item, index) => (
//                           <tr key={item.supplierVisaPriceId}>
//                             <td>
//                               <div className="fw-bold fs-6 text-primary">
//                                 {item.supplierName}
//                               </div>
//                               <div className="text-muted small">
//                                 {item.visaName}
//                               </div>
//                               <div className="mt-1">
//                                 <span className="badge bg-success me-2">
//                                   Adult: {item.adultPrice}
//                                 </span>
//                                 <span className="badge bg-info">
//                                   Child: {item.childPrice}
//                                 </span>
//                               </div>
//                             </td>
//                             <td>
//                               <div className="d-flex align-items-center mb-1">
//                                 <i className="ri-phone-line text-success me-2"></i>
//                                 {item.phoneNumber || "N/A"}
//                               </div>
//                               <div className="d-flex align-items-center">
//                                 <i className="ri-mail-line text-danger me-2"></i>
//                                 {item.email}
//                               </div>
//                             </td>
//                             <td>
//                               <button
//                                 className="btn btn-sm btn-success"
//                                 onClick={() =>
//                                   handleSupplierSelection(item, index)
//                                 }
//                               >
//                                 Apply
//                               </button>
//                             </td>
//                           </tr>
//                         ))
//                       ) : (
//                         <tr>
//                           <td colSpan="3" className="text-center py-3">
//                             No suppliers found
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn btn-danger"
//                   onClick={handleCloseSupplierModal}
//                 >
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Confirmation Modal */}
//       {showConfirmationModal && pendingSupplierAction && (
//         <div
//           className="modal fade show d-block modal-overlay"
//           tabIndex="-1"
//           role="dialog"
//           style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//         >
//           <div className="modal-dialog modal-dialog-centered" role="document">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title text-warning">
//                   <i className="ri-alert-line me-2"></i>
//                   Confirm Application
//                 </h5>
//               </div>
//               <div className="modal-body">
//                 <div className="text-center mb-3">
//                   <i className="ri-question-line display-4 text-warning"></i>
//                 </div>
//                 <p className="text-center mb-3">
//                   Are you sure you want to apply for this visa with{" "}
//                   <strong>{pendingSupplierAction.supplier.supplierName}</strong>
//                   ?
//                 </p>
//                 <div className="alert alert-info">
//                   <div className="d-flex flex-column">
//                     <span>
//                       <strong>Visa:</strong> {selectedVisa?.visaName}
//                     </span>
//                     <span>
//                       <strong>Country:</strong> {selectedCountry}
//                     </span>
//                     <span>
//                       <strong>Supplier:</strong>{" "}
//                       {pendingSupplierAction.supplier.supplierName}
//                     </span>
//                     <div className="mt-2">
//                       <span className="badge bg-success me-2">
//                         Adult Price: ₹
//                         {pendingSupplierAction.supplier.adultPrice}
//                       </span>
//                       <span className="badge bg-info">
//                         Child Price: ₹
//                         {pendingSupplierAction.supplier.childPrice}
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//                 <p className="text-muted small text-center">
//                   After confirmation, you will be redirected to add applicant
//                   details.
//                 </p>
//               </div>
//               <div className="modal-footer justify-content-end">
//                 <button
//                   type="button"
//                   className="btn btn-danger me-3"
//                   onClick={handleCancelApplication}
//                 >
//                   <i className="ri-close-line me-1"></i> Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-success"
//                   onClick={handleConfirmedApplication}
//                 >
//                   <i className="ri-check-line me-1"></i> Confirm & Apply
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Visa Applicant Form Modal */}
//       {showApplicantForm && createdVisaRequest && (
//         <ApplicantForm
//           show={showApplicantForm}
//           onHide={handleApplicantFormClose}
//           visaRequestId={createdVisaRequest.visaRequestId}
//           onSuccess={handleApplicantFormSuccess}
//           applicantsList={applicantsList}
//         />
//       )}
//     </div>
//   );
// }



import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Header from "../../Common/Layout/Header";
import styles from "./Search.module.css";
import config from "../../Common/Configurations/APIConfig";
import moment from "moment";
import VisaTabs from "../AllTabs/VisaTabs";
import { useAuth } from "../../Common/Configurations/AuthContext";
import apiService from "../../Common/Configurations/APIService";
import ApplicantForm from "./ApplicantForm";
import VisaOffers from "../Advertisements/VisaOffers";
import VisaSidebarOffers from "../Advertisements/VisaSidebarOffers";
import DefaultData from "../../CompanyData/DefaultData";

// Add CSS for z-index management
const customStyles = `
  .search-visas-container .search-dropdown-wrapper {
    position: relative;
    z-index: 1050;
  }
  
  .search-visas-container .search-suggestions-list {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #dee2e6;
    border-top: none;
    border-radius: 0 0 0.375rem 0.375rem;
    max-height: 300px;
    overflow-y: auto;
    z-index: 1060;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    margin-top: -1px;
  }
  
  .search-visas-container .modal-overlay {
    z-index: 1080 !important;
  }
  
  .search-visas-container .sticky-header {
    position: sticky;
    top: 0;
    background: white;
    z-index: 1040;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  
  .search-visas-container .hot-deals-section {
    position: relative;
    z-index: 1;
  }
  
  .search-visas-container .sidebar-sticky {
    position: sticky;
    top: 100px;
    z-index: 2;
  }
  
  .search-visas-container .main-content-section {
    position: relative;
    z-index: 1;
  }
`;

export default function Visas() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const today = new Date();
  const [inputValue, setInputValue] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [visas, setVisas] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [terms, setTerms] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [loadingStates, setLoadingStates] = useState({});
  const [searchLoading, setSearchLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedVisa, setSelectedVisa] = useState(null);
  const [showVisaModal, setShowVisaModal] = useState(false);
  const [shareLoading, setShareLoading] = useState(false);
  const [showApplicantForm, setShowApplicantForm] = useState(false);
  const [createdVisaRequest, setCreatedVisaRequest] = useState(null);
  const [applicantsList, setApplicantsList] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
 const companyId =
      DefaultData.DEFAULTCOMPANYID;
  // Add custom styles to document head
  useEffect(() => {
    const styleElement = document.createElement("style");
    styleElement.innerHTML = customStyles;
    document.head.appendChild(styleElement);

    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  const handleReset = () => {
    setInputValue("");
    setFilteredSuggestions([]);
    setIsDropdownVisible(false);
    setSelectedCountry(null);
    setVisas([]);
    setDocuments([]);
    setTerms([]);
    setFaqs([]);
    setLoadingStates({});
    setSearchLoading(false);
    setSelectedVisa(null);
    setShowVisaModal(false);
    setShareLoading(false);
    setShowApplicantForm(false);
    setCreatedVisaRequest(null);
    setApplicantsList([]);
    setHasSearched(false);
  };

  // Autocomplete API call
  const fetchAutocomplete = async (query) => {
    try {
      const url = `${config.GETCOUNTRIES}?query=${encodeURIComponent(query)}`;
      const response = await apiService.getAll(url);
      return response;
    } catch (error) {
      console.error("Error fetching autocomplete:", error);
      return [];
    }
  };

  // B2B Country Details API call
  const fetchB2BCountryDetails = async (countryName) => {
    try {
      const url = `${config.GETB2BVISAS}?countryName=${encodeURIComponent(countryName)}`;
      const response = await apiService.getAll(url);
      return response;
    } catch (error) {
      console.error("Error fetching B2B country details:", error);
      return null;
    }
  };

  const handleInputChange = async (e) => {
    const query = e.target.value;
    setInputValue(query);

    if (query.length > 0) {
      setSearchLoading(true);
      
      try {
        const suggestions = await fetchAutocomplete(query);
        setFilteredSuggestions(suggestions);
        setIsDropdownVisible(true);
      } catch (error) {
        console.error("Error in autocomplete:", error);
        setFilteredSuggestions([]);
      } finally {
        setSearchLoading(false);
      }
    } else {
      setFilteredSuggestions([]);
      setIsDropdownVisible(false);
      setSearchLoading(false);
    }
  };

  const handleSuggestionClick = async (suggestion) => {
    setInputValue(suggestion.name);
    setSelectedCountry(suggestion.name);
    setIsDropdownVisible(false);
    setSearchLoading(true);
    setHasSearched(true);

    try {
      const countryData = await fetchB2BCountryDetails(suggestion.name);
      
      if (countryData) {
        console.log("Country Data:", countryData);
        
        if (countryData.visas && countryData.visas.length > 0) {
          setVisas(countryData.visas);
          
          const initialLoadingStates = {};
          countryData.visas.forEach((visa, index) => {
            initialLoadingStates[index] = false;
          });
          setLoadingStates(initialLoadingStates);
        } else {
          setVisas([]);
        }

        if (countryData.visaDocuments && countryData.visaDocuments.length > 0) {
          setDocuments(countryData.visaDocuments);
        } else {
          setDocuments([]);
        }

        if (countryData.visaTerms && countryData.visaTerms.length > 0) {
          setTerms(countryData.visaTerms);
        } else {
          setTerms([]);
        }

        if (countryData.visaFAQs && countryData.visaFAQs.length > 0) {
          setFaqs(countryData.visaFAQs);
        } else {
          setFaqs([]);
        }
      } else {
        setVisas([]);
        setDocuments([]);
        setTerms([]);
        setFaqs([]);
      }
    } catch (error) {
      console.error("Error fetching country details:", error);
      setVisas([]);
      setDocuments([]);
      setTerms([]);
      setFaqs([]);
    } finally {
      setSearchLoading(false);
    }
  };

  const handleViewVisa = (visa) => {
    setSelectedVisa(visa);
    setShowVisaModal(true);
  };

  // Function to fetch applicants for a visa request
  const GetApplicants = async (visaRequestId) => {
    try {
      const url = `${config.GETVISAAPPLICANTSBYREQUEST}/${visaRequestId}`;
      console.log("Fetching applicants from:", url);
      const res = await apiService.getAll(url);
      setApplicantsList(res || []);
    } catch (error) {
      console.error("Error fetching applicants:", error);
      setApplicantsList([]);
    }
  };

  // Helper function to safely parse numbers
  const parseNumber = (value) => {
    if (typeof value === 'number') return value;
    if (typeof value === 'string') {
      const parsed = parseFloat(value);
      return isNaN(parsed) ? 0 : parsed;
    }
    return 0;
  };

  // Handle Apply button click - Creates visa request with proper numeric calculations
  const handleApply = async (e, visa, index) => {
    e.preventDefault();

    setLoadingStates((prev) => ({
      ...prev,
      [index]: true,
    }));

    try {
      // Get prices from the visa object and ensure they are numbers
      const adultPrice = parseNumber(visa.b2BPrice?.adultPrice);
      const childPrice = parseNumber(visa.b2BPrice?.childPrice);
      const serviceFeePerApplicant = parseNumber(DefaultData.SERVICEFEE);

      console.log("Price breakdown:", {
        adultPrice,
        childPrice,
        serviceFeePerApplicant
      });

      // For initial request creation, set default to 1 adult applicant
      const noOfApplicants = 1;
      
      // Calculate ALL prices as numbers to prevent string concatenation
      const totalSupplierPrice = adultPrice; // This is the B2B price for 1 adult
      const totalServiceFee = serviceFeePerApplicant; // Service fee for 1 applicant
      const totalPrice = totalSupplierPrice + totalServiceFee; // Addition as numbers
      const customerPrice = totalPrice; // Customer pays the total price
      const gst = 0; // No GST as per your model
      const markUP = 0; // No markup as per your model

      console.log("Calculated prices:", {
        totalSupplierPrice,
        totalServiceFee,
        totalPrice,
        customerPrice,
        gst,
        markUP
      });

      // Calculate expected date based on processing time
      const processingDays = parseInt(visa?.processingTime) || 5;
      const expectedDate = new Date(today);
      expectedDate.setDate(today.getDate() + processingDays + 1);

      // Create request object with ALL price fields as numbers
      const formData = {
        // Core identifiers
        visaId: visa.visaId,
        userId: user?.id,
        companyId: companyId,
        
        // Visa details
        leadSource: "B2B",
        visaName: visa.visaName,
        countryName: selectedCountry,
        
        // Dates
        travelDate: moment(new Date()).format("YYYY-MM-DD"),
        expectedDate: moment(expectedDate).format("YYYY-MM-DD"),
        
        // Applicant count
        noOfApplicants: noOfApplicants,
        
        // ALL PRICE FIELDS - Ensure these are numbers, not strings
        supplierPrice: totalSupplierPrice,    // Number
        gst: gst,                             // Number
        markUP: markUP,                        // Number
        serviceFee: totalServiceFee,           // Number
        customerPrice: customerPrice,          // Number
        totalPrice: totalPrice,                 // Number
        
        // Status fields
        visaRequestStatus: "PENDING",
        paymentStatus: "PENDING",
        
        // Optional fields
        comments: "",
        paymentGatewayNo: "",
        paymentGateway: "",
        applicantName: "",
        
        // Additional price fields for reference
        adultPrice: adultPrice,
        childPrice: childPrice
      };

      // Log the final form data to verify all values are numbers
      console.log("Final form data being sent:", JSON.stringify(formData, null, 2));
      
      // Verify that totalPrice is calculated correctly
      console.log("Verification - 1500 + 200 =", 1500 + 200, "vs calculated:", totalPrice);
      
      if (totalSupplierPrice === 1500 && totalServiceFee === 200) {
        console.log("Total price should be 1700, calculated as:", totalPrice);
      }

      const res = await apiService.post(config.CREATEVISAREQUEST, formData);
      
      console.log("Visa request created successfully:", res);
      setCreatedVisaRequest(res);
      
      // Open applicant form immediately after request creation
      setShowApplicantForm(true);
      
      // Fetch applicants if any exist
      setTimeout(() => {
        if (res.visaRequestId) {
          GetApplicants(res.visaRequestId);
        }
      }, 100);
      
    } catch (error) {
      console.error("Error creating visa request:", error);
      alert("Failed to create visa request. Please try again.");
    } finally {
      setLoadingStates((prev) => ({
        ...prev,
        [index]: false,
      }));
    }
  };

  // Format price to use B2B price from API (for display)
  const formatPrice = (visa) => {
    if (visa.b2BPrice) {
      return (
        <div className="d-flex flex-column">
          {visa.b2BPrice.adultPrice > 0 && (
            <span className="fw-bold text-success">
              Adult: INR{visa.b2BPrice.adultPrice}
            </span>
          )}
          {visa.b2BPrice.childPrice > 0 && (
            <span className="fw-bold text-primary">
              Child: INR{visa.b2BPrice.childPrice}
            </span>
          )}
        </div>
      );
    } else {
      return <span className="text-warning fw-bold">Contact for price</span>;
    }
  };

  const shareViaWhatsApp = async (visa) => {
    setShareLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 500));

    const websiteUrl = "https://www.visaproservices.com";
    
    const priceInfo = visa.b2BPrice
      ? `• *Adult Price:* ₹${visa.b2BPrice.adultPrice || "N/A"}\n• *Child Price:* ₹${visa.b2BPrice.childPrice || "N/A"}`
      : "• *Price:* Contact for details";

    const message = `🏢 *${user?.brandName || "Visa Services"}*

🌟 *Visa Information for ${selectedCountry}* 🌟

📋 *Visa Details:*
• *Visa Name:* ${visa.visaName}
• *Type:* ${visa.visaType}
• *Entry:* ${visa.entry}
• *Stay Period:* ${visa.stayPeriod}
• *Validity:* ${visa.validity}

💰 *Pricing (INR):*
${priceInfo}

📄 *Required Documents:*
${documents.map((doc, index) => `• ${doc.documentName}`).join("\n")}

🌐 *Apply Now:* ${websiteUrl}/apply?country=${encodeURIComponent(
      selectedCountry
    )}&visa=${encodeURIComponent(visa.visaName)}

💬 *Thank you for your interest in ${user?.brandName || "Visa Services"}!

👤 *Contact Details:*
• *Name:* ${user?.name || "N/A"}
• *Email:* ${user?.email || "N/A"}
• *Phone:* ${user?.phoneNumber || "N/A"}

*Note:* Terms and conditions apply.`;

    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://web.whatsapp.com/send?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");
    setShareLoading(false);
  };

  // Handle applicant form success
  const handleApplicantFormSuccess = () => {
    if (createdVisaRequest) {
      GetApplicants(createdVisaRequest.visaRequestId);
    }
  };

// In Visas.js - Update the handleApplicantFormClose function
const handleApplicantFormClose = () => {
  setShowApplicantForm(false);
  if (createdVisaRequest) {
    // Pass the documents data in navigation state
    navigate(`/request/${createdVisaRequest.visaRequestId}`, {
      state: {
        documents: documents, // Pass the documents from the current search
        visaId: selectedVisa?.visaId,
        visaName: selectedVisa?.visaName
      }
    });
  }
};
  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
    return null;
  }

  return (
    <div id="layout-wrapper" className="search-visas-container">
      <Header />
      <div className="vertical-overlay"></div>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row" id="contactList">
              <div className="col-lg-12">
                <div className="card">
                  <div className="p-2">
                    <VisaTabs pageName="VISAS" />
                  </div>
                  <div className="card-header d-flex align-items-center border-0">
                    <h5 className="card-title mb-0 flex-grow-1">
                      SEARCH & APPLY VISAS
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="row g-2 align-items-center">
                      <div className="col-xl-4 col-md-6">
                        <div className="search-box">
                          <input
                            type="text"
                            value={inputValue}
                            onChange={handleInputChange}
                            placeholder="Enter country Name..."
                            className="form-control"
                          />
                        </div>
                        {isDropdownVisible && (
                          <ul className={styles.suggestionsList}>
                            {filteredSuggestions.map((suggestion) => (
                              <li
                                key={suggestion.id || suggestion.countryUrl}
                                className={`${styles.suggestionItem} list-group-item list-group-item-action`}
                                onClick={() => handleSuggestionClick(suggestion)}
                              >
                                <span className={styles.flag}>
                                  <img
                                    src={`https://flagcdn.com/w40/${suggestion.flagSrc?.toLowerCase()}.png`}
                                    alt={suggestion.name}
                                    className={styles.flagImage}
                                    onError={(e) => {
                                      e.target.src = 'https://flagcdn.com/w40/un.png';
                                    }}
                                  />
                                </span>
                                {suggestion.name}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>

                      <div className="col-auto">
                        <button
                          className="btn btn-danger"
                          onClick={handleReset}
                        >
                          <i className="ri-refresh-line align-bottom me-1"></i> Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {hasSearched && (
                  <div className="row mt-3">
                    <div className="col-lg-3">
                      <div className="card">
                        <div className="card-body">
                          <div className="sidebar-sticky">
                            <VisaSidebarOffers />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-9 main-content-section">
                      <div className="card">
                        <div className="card-body">
                          <div className="table-responsive table-card">
                            <table
                              className="table align-middle table-nowrap"
                              id="customerTable"
                            >
                              <thead className="table-light text-muted">
                                <tr>
                                  <th>SNo</th>
                                  <th>Visa Details</th>
                                  <th>Validity</th>
                                  <th>Price (INR)</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody className="list form-check-all">
                                {searchLoading ? (
                                  <tr>
                                    <td colSpan="5" className="text-center py-3">
                                      <div
                                        className="spinner-border text-primary"
                                        role="status"
                                      >
                                        <span className="visually-hidden">
                                          Loading...
                                        </span>
                                      </div>
                                    </td>
                                  </tr>
                                ) : visas.length > 0 ? (
                                  visas.map((v, index) => (
                                    <tr key={v.visaId || index}>
                                      <td className="sno">{index + 1}</td>
                                      <td>
                                        <div className="d-flex flex-column">
                                          <span className="fw-semibold">
                                            {v.visaName}
                                          </span>
                                          <div className="d-flex flex-wrap gap-2 mt-1">
                                            <span className="badge bg-primary text-white">
                                              {v.visaType}
                                            </span>
                                            <span className="badge bg-success text-white">
                                              {v.entry}
                                            </span>
                                            <span className="badge bg-info text-white">
                                              {v.stayPeriod}
                                            </span>
                                          </div>
                                        </div>
                                      </td>
                                      <td className="validity">{v.validity}</td>
                                      <td className="price">
                                        {formatPrice(v)}
                                      </td>
                                      <td className="status">
                                        <button
                                          className="btn btn-sm btn-primary edit-item-btn me-2"
                                          onClick={() => handleViewVisa(v)}
                                          title="View Visa Details"
                                          disabled={loadingStates[index]}
                                        >
                                          <i className="ri-eye-line me-1"></i> View
                                        </button>
                                        <button
                                          className="btn btn-sm btn-success edit-item-btn"
                                          onClick={(e) => handleApply(e, v, index)}
                                          disabled={loadingStates[index]}
                                        >
                                          {loadingStates[index] ? (
                                            <>
                                              <div
                                                className="spinner-border spinner-border-sm me-1"
                                                role="status"
                                              >
                                                <span className="visually-hidden">Loading...</span>
                                              </div>
                                              APPLYING...
                                            </>
                                          ) : (
                                            "APPLY"
                                          )}
                                        </button>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="5" className="text-center py-4">
                                      <div className="text-muted">
                                        <i className="ri-search-line display-4"></i>
                                        <p className="mt-2">
                                          No visas found for the selected country
                                        </p>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>

                          {visas.length > 0 && (
                            <>
                              <div className="mb-3">
                                <div className="list-group nested-list nested-sortable">
                                  <div className="list-group-item nested-1">
                                    Documents
                                    <div className="list-group nested-list nested-sortable">
                                      {documents.length > 0 ? (
                                        documents.map((d, index) => (
                                          <div
                                            key={index}
                                            className="list-group-item nested-2"
                                          >
                                            {index + 1}. {d.documentName}
                                          </div>
                                        ))
                                      ) : (
                                        <div className="list-group-item nested-2 text-muted">
                                          No documents required
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="mb-3">
                                <div className="list-group nested-list nested-sortable">
                                  <div className="list-group-item nested-1">
                                    Terms and Conditions
                                    <div className="list-group nested-list nested-sortable">
                                      {terms.length > 0 ? (
                                        terms.map((d, index) => (
                                          <div
                                            key={index}
                                            className="list-group-item nested-2"
                                          >
                                            {index + 1}. {d.termsAndConditions || d.termsandConditions}
                                          </div>
                                        ))
                                      ) : (
                                        <div className="list-group-item nested-2 text-muted">
                                          No terms available
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="mb-3">
                                <div className="list-group nested-list nested-sortable">
                                  <div className="list-group-item nested-1">
                                    Frequently Asked Questions
                                    <div className="list-group nested-list nested-sortable">
                                      {faqs.length > 0 ? (
                                        faqs.map((d, index) => (
                                          <div
                                            key={index}
                                            className="list-group-item nested-2"
                                          >
                                            {d.question}
                                            <div className="list-group-item nested-3">
                                              {d.answer}
                                            </div>
                                          </div>
                                        ))
                                      ) : (
                                        <div className="list-group-item nested-2 text-muted">
                                          No FAQs available
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {!hasSearched && (
                <div className="hot-deals-section mt-3">
                  <VisaOffers />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Visa Details Modal */}
      {showVisaModal && selectedVisa && (
        <div
          className="modal fade show d-block modal-overlay"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Visa Details - {selectedVisa.visaName}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowVisaModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12 mb-3">
                    <h6>Visa Information</h6>
                    <div className="row">
                      <div className="col-md-4 mb-2">
                        <div className="d-flex justify-content-between border p-2 rounded">
                          <span className="fw-bold">Visa Type:</span>
                          <span>{selectedVisa.visaType}</span>
                        </div>
                      </div>
                      <div className="col-md-4 mb-2">
                        <div className="d-flex justify-content-between border p-2 rounded">
                          <span className="fw-bold">Entry Type:</span>
                          <span>{selectedVisa.entry}</span>
                        </div>
                      </div>
                      <div className="col-md-4 mb-2">
                        <div className="d-flex justify-content-between border p-2 rounded">
                          <span className="fw-bold">Stay Period:</span>
                          <span>{selectedVisa.stayPeriod}</span>
                        </div>
                      </div>
                      <div className="col-md-4 mb-2">
                        <div className="d-flex justify-content-between border p-2 rounded">
                          <span className="fw-bold">Validity:</span>
                          <span>{selectedVisa.validity}</span>
                        </div>
                      </div>
                      <div className="col-md-4 mb-2">
                        <div className="d-flex justify-content-between border p-2 rounded">
                          <span className="fw-bold">Processing Time:</span>
                          <span>{selectedVisa.processingTime} days</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-3">
                  <h6>Required Documents</h6>
                  <div className="list-group">
                    {documents.length > 0 ? (
                      documents.map((doc, index) => (
                        <div key={index} className="list-group-item">
                          {index + 1}. {doc.documentName}
                        </div>
                      ))
                    ) : (
                      <div className="list-group-item text-muted">
                        No documents required
                      </div>
                    )}
                  </div>
                </div>

                {selectedVisa.b2BPrice && (
                  <div className="mt-3">
                    <h6>Pricing</h6>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="alert alert-success mb-0">
                          <strong>Adult Price:</strong> ₹{selectedVisa.b2BPrice.adultPrice}
                        </div>
                      </div>
                      {selectedVisa.b2BPrice.childPrice > 0 && (
                        <div className="col-md-6">
                          <div className="alert alert-info mb-0">
                            <strong>Child Price:</strong> ₹{selectedVisa.b2BPrice.childPrice}
                          </div>
                        </div>
                      )}
                    </div>
                    <small className="text-muted">* These exact prices will be stored in the database</small>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setShowVisaModal(false)}
                  disabled={shareLoading}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary text-white"
                  onClick={() => shareViaWhatsApp(selectedVisa)}
                  disabled={shareLoading}
                >
                  {shareLoading ? (
                    <>
                      <div
                        className="spinner-border spinner-border-sm me-1"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      SHARING...
                    </>
                  ) : (
                    <>
                      <i className="ri-whatsapp-line me-1"></i> Share
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Visa Applicant Form Modal */}
      {showApplicantForm && createdVisaRequest && (
        <ApplicantForm
          show={showApplicantForm}
          onHide={handleApplicantFormClose}
          visaRequestId={createdVisaRequest.visaRequestId}
          onSuccess={handleApplicantFormSuccess}
          applicantsList={applicantsList}
        />
      )}
    </div>
  );
}